import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function locationsReducer(state = initialState.locations, action) {
  switch (action.type) {
    case types.LOAD_LOCATIONS_SUCCESS:
      return {
        ...action.locations,
        saveError: initialState.locations.saveError,
        saveInfo: initialState.locations.saveInfo
      };
    case types.SAVE_LOCATION_SUCCESS: {
      let locationToAdd = action.location;
      let newState = [...state.items].map((x) => {
        let returnVal = {...x};
        if (returnVal.id == locationToAdd.id) {
          return {...locationToAdd};
        }
        return returnVal;
      });

      if (!_.some(state.items, y => y.id == locationToAdd.id)) {
        newState = [...newState, locationToAdd];
      }
      return {
        ...state,
        items: _.sortBy(newState, x => x.locationName.toLowerCase()),
        saveError: initialState.locations.saveError,
        saveInfo: {...state.saveInfo, saved: true, saving: false, isNew: action.isNew, location: locationToAdd},
      };
    }
    case types.DELETE_LOCATION_SUCCESS:
      return {
        ...state,
        items: [...state.items.filter(x => x.id != action.location.id)],
        saveError: initialState.locations.saveError,
        saveInfo: {...state.saveInfo, saved: true, saving: false,},
      };
    case types.SAVE_LOCATION_ERROR:
      return {
        ...state, saveError: action.saveError,
        saveInfo: {...state.saveInfo, saved: true, saving: false},
      };
    case types.SAVE_LOCATION_SAVING:
      return {...state, saveInfo: {...action.saveInfo}};
    default:
      return state;
  }
}
